import { useMemo } from 'react';
import mitt, { Emitter } from 'mitt';
import { MessageInsightsPanelSource, PanelEvents } from '../types';

const emitterMap = new Map<MessageInsightsPanelSource, Emitter<PanelEvents>>();

export function usePanelEmitter(source: MessageInsightsPanelSource): Emitter<PanelEvents> {
  return useMemo<Emitter<PanelEvents>>(() => {
    const existing = emitterMap.get(source);
    if (existing) {
      return existing;
    }
    const newEmitter = mitt<PanelEvents>();
    emitterMap.set(source, newEmitter);
    return newEmitter;
  }, [source]);
}
